import Control from '../1. Core/Control';
import DataTable from '../1. Core/Controls/DataTable/DataTable';
import TopAppBar from '../1. Core/Controls/TopAppBar/TopAppBar';
import Delegate from '../1. Core/Delegate';
import './FantasyList.scss';
import {Promocode, VideoSource} from './types';
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import ListItem from "../1. Core/Controls/ListBox/ListItem";
import Menu from "../1. Core/Controls/Menu/Menu";
import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";
import EditPromocodeSourceDialog from "./EditPromocodeSourceDialog";


export default class PromocodeList extends Control {
    private _topAppBar: TopAppBar;
    private EvShowPageModeClick: Delegate;

    private _dataTable: DataTable;
    private _dataWithFiltersNode: HTMLElement;
    private _ShowAppBar: boolean;

    constructor(settings: object) {
        super(settings);
        this._render();
    }

    _initFields(settings: object) {
        this._ShowAppBar = true;
        this.EvShowPageModeClick = new Delegate();
        super._initFields(settings);
    }

    _render() {
        this.np_render();
        this.addClass('');


        if (this._ShowAppBar)
            this._topAppBar = new TopAppBar({
                Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
                Caption: 'Promocodes',
                ParentNode: this._root,
                ShowSearchButton: false,
                MainButton: {
                    FontImage: NP.FontImages.menu,
                    EvClick: () => this.EvShowPageModeClick.fire(this)
                },
                RightItems: NP.getCurrentUser().isBDAdmin() ? [
                    new IconToggleButton({
                        FontImage: NP.FontImages.add,
                        EvClick: () => {
                            new EditPromocodeSourceDialog({EvOkButtonClick: () => this.refreshList()}).show();
                        }
                    }),
                ] : [],
            });

        this._dataWithFiltersNode = NP.createNode(this._root, 'data-with-filters-container');


        this._dataTable = new DataTable({
            ParentNode: this._dataWithFiltersNode,
            ShowSettingsButton: NP.getCurrentUser().isBDAdmin(),
            Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
            MultiSelect: false,
            ShowRowIndex: false,
            EnableSort: false,
            ImageWidth: 32,
            Columns: [{
                Content: 'Number',
                Width: '10%',
                PropertyContent: 'number'
            },{
                Content: 'Code',
                Width: '40%',
                PropertyContent: 'code'
            }, {
                Content: 'Type',
                PropertyContent: 'type',
                Width: '40%'
            },{
                Content: 'MaxClaimCount',
                PropertyContent: 'maxClaimCount',
                Width: '20%'
            }, {
                Width: '20%',
                Content: 'Quantity',
                PropertyContent: 'quantity'
            }, {
                Width: '20%',
                Content: 'Claim Count',
                PropertyContent: 'claimCount'
            }],
            ShowPaginator: false,
            EvItemClick: (s: object, e: { Item: Promocode }) => {
                new EditPromocodeSourceDialog({
                    Promocode: e.Item,
                    EvOkButtonClick: () => this.refreshList()
                }).show()
            },
            EvSortClick: (s: DataTable, e: any) => {
                e.CanceSort = true;
                this.refreshList();
            },
            EvItemContextMenu: async (s: any, e: { Event: any, Item: VideoSource }) => {
                if (!NP.getCurrentUser().isBDAdmin())
                    return;

                let menu = new Menu({
                    Items: [{
                        FontImage: NP.FontImages.edit,
                        RK: 'Edit',
                        Value: 'Edit',
                    }, {
                        FontImage: NP.FontImages.delete,
                        RK: 'Remove',
                        Value: 'Remove',
                    }],
                    EvItemSelected: async (s: Menu, event: { Item: ListItem }) => {

                        switch (event.Item.getValue()) {
                            case 'Edit':
                                new EditPromocodeSourceDialog({
                                    Promocode: e.Item,
                                    EvOkButtonClick: () => this.refreshList()
                                }).show()
                                break
                            case 'Remove':
                                NP.showConfirm({
                                    Content: NP.RM.getString('AreYouS'),
                                    EvOkButtonClick: async () => {
                                        await ServerAPI.callUiApi("/promocode/" + e.Item.id, null, 'DELETE');
                                        this.refreshList();
                                    }
                                })
                                break
                        }


                    }
                });
                menu.showContextMenu(e.Event);
            }
        });
    }



    setHeight(value: number) {
        super.setHeight(value);
        let h = this._Height - (this._topAppBar ? this._topAppBar.getOffsetHeight() : 0);
        this._dataTable.setHeight(h);
    }

    setWidth(value: number) {
        super.setWidth(value);
        this._dataTable.setWidth(value);
        if (this._dataTable.getIsSmall()) {
            if (this._topAppBar)
                this._topAppBar.removeClass('top-app-bar--no-shadow');
            this.setHeight(this._Height);
        } else {
            if (this._topAppBar)
                this._topAppBar.addClass('top-app-bar--no-shadow');
            this.setHeight(this._Height);
        }

    }

    refresh() {
        this.refreshList();
    }

    private async refreshList() {
        let sources = await ServerAPI.get<Promocode[]>("/promocode/all")

        this._dataTable.setRows(sources.map((it, idx) => ({
            ...it,
            number: idx + 1,
        })));
    }

    getTopAppBar() {
        return this._topAppBar;
    }
}